<script>
import { isValidPassword, PASSWORD_CONDITIONS } from '@/utils/validation';
import { iIcon, iTextInput } from '@inscribe/signal';

export default {
  components: {
    iIcon,
    iTextInput,
  },
  props: {
    autoFocus: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Password',
    },
    value: {
      type: String,
      default: undefined,
    },
    displayHint: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showPassword: false,
    };
  },
  computed: {
    isValidPassword() {
      return isValidPassword(this.value);
    },
    passwordCriteria() {
      return Object.keys(PASSWORD_CONDITIONS).map((key) => ({
        message: PASSWORD_CONDITIONS[key].message,
        isValid: PASSWORD_CONDITIONS[key].condition.test(this.value),
      }));
    },
  },
};
</script>

<template>
  <div class="password-input">
    <i-text-input
      :label="label"
      :value="value"
      placeholder="A strong password"
      name="password"
      :type="showPassword ? 'text' : 'password'"
      :has-error="displayHint && !isValidPassword"
      :show-hint-text="displayHint && !isValidPassword"
      hint-text="A valid password is required"
      :right-icon="showPassword ? 'small-edit-view-off' : 'small-edit-view'"
      data-testid="password-input-text"
      @input="$emit('input', $event)"
      @on-right-icon-click="showPassword = !showPassword"
    >
    </i-text-input>

    <div class="password-criteria d-flex flex-wrap i-mt-9 i-gap-3">
      <div
        v-for="criteria in passwordCriteria"
        :key="criteria.message"
        class="criteria d-flex flex-row align-items-center i-gap-3"
      >
        <div
          :class="{ valid: criteria.isValid }"
          class="circle d-flex flex-align-center"
        >
          <i-icon
            v-if="criteria.isValid"
            symbol="small_check_1"
            colour="#ffffff"
            class="menu-icon"
            :size="10"
          ></i-icon>
        </div>
        <div class="i-text-subheading-3 i-text-neutral-110">
          {{ criteria.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.password-input {
  position: relative;
  &.narrow {
    .password-criteria {
      max-width: 60%;
      @include respond-to('medium') {
        max-width: 100%;
      }
    }
  }
  .password-criteria {
    > div {
      width: 46%;
    }
    .criteria {
      .circle {
        width: 12px;
        height: 12px;
        border: 1px solid $light-neutral-70;
        border-radius: 50%;

        &.valid {
          border: 1px solid $light-success-90;
          background: $light-success-90;
        }
      }
    }
  }

  .password-visibility {
    position: absolute;
    right: 16px;
    top: 36px;
    color: $color-navy-blue-40;

    &:hover {
      color: $color-navy-blue-80;
    }
  }
}
</style>
